String.prototype.__defineGetter__('dateFromMysqlTimestamp', function () {
    if (this.length === 0)
        return new Date();
    return new Date(Date.parse(this));
});
String.prototype.__defineGetter__('dateFromMysqlUTCTimestamp', function () {
    if (this.length === 0)
        return new Date();
    const t = this.split(/[- :]/);
    // @ts-ignore
    return new Date(Date.UTC(t[0], t[1] - 1, t[2], t[3], t[4], t[5]));
});
String.prototype.stripTags = function () {
    return this.replace(/<\/?[^>]+>/g, '');
};
String.prototype.replaceAll = function (search, replacement) {
    return this.replace(new RegExp(search, 'g'), replacement);
};
